import React from "react"

function Header() {
  return <div className='Title'>Tic Tac Toe</div>
}

export default Header